<div [id]="id" tabindex="-1"
     class="fixed top-0 left-0 right-0 z-50 hidden w-full p-4 overflow-x-hidden overflow-y-auto h-full md:inset-0">
    <div class="w-96 max-h-[80vh] rounded-lg bg-white overflow-y-auto">
        <div class="fixed top-40 primary-purple-light-2-background p-8 rounded-lg shadow dark:bg-gray-700">
            <div class="flex justify-center">
                 <h3 class="w-full text-base font-bold dark:text-gray-400">{{ literalService.get(editable ? 'bookings.modal.editField' : 'bookings.data.seats', true) }}</h3>
                <button (click)="modal.hide()" type="button"
                    class="absolute top-8 right-8 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ml-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
                   >
                    <img [src]="images.close" class="h-6 w-6" />
                </button>
            </div>
            <div class="mb-4 mt-6" [ngClass]="{'neutrals-grey-03-text': confirmChange}">
                <!--div class="flex items-center justify-center mb-6 space-x-1">
                    <img [src]="images.booking.seats" alt="detailImage" class="h-5 w-5 imgColor" />
                    <label class="text-base font-normal">{{ literalService.get('bookings.data.seats', true) }}</label>
                </div-->
                @if (booking) {
                    @if (editable) {
                        <div class="w-fit">
                            <app-seats-input [seats]="booking.bookingSeats" [disabled]="confirmChange" (changeEventEmitter)="change($event)" />
                        </div>
                    }

                    <!-- Seats rows -->
                    <div class="overflow-x-auto mt-6">
                        <div class="max-h-64 overflow-y-auto">
                            @for (seat of booking.bookingSeats; track $index; let seatIndex = $index) {
                                <div class="flex gap-4 items-end mb-4 text-sm">
                                    <!-- Profile dropdown -->
                                    @if (editable && !confirmChange) {
                                        <button type="button"
                                            class="profile-trigger w-10 h-10 shrink-0 flex items-center justify-center cursor-pointer neutrals-white-background border rounded!"
                                            [attr.popovertarget]="'profilePopover-' + seatIndex"
                                            [style.anchor-name]="'--profileAnchor-' + seatIndex">
                                            <img [src]="getProfileImage(seat.profile, seat.prm)" class="h-5 w-5 rounded-full" alt="profile">
                                        </button>
                                        <div #profilePopover popover [id]="'profilePopover-' + seatIndex"
                                            class="dropdown"
                                            [style.position-anchor]="'--profileAnchor-' + seatIndex">
                                            <div class="rounded bg-white shadow p-1 flex flex-col gap-2 max-h-64 scrollable-content">
                                                @for (profile of profiles; track $index) {
                                                    <div class="menu-option cursor-pointer flex justify-center items-center p-1 rounded"
                                                        (click)="seat.profile = profile; profilePopover.hidePopover()">
                                                        <img [src]="getProfileImage(profile, seat.prm)" class="h-5 w-5 rounded-full" alt="profile">
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    } @else {
                                        <div class="w-10 h-10 shrink-0 flex items-center">
                                            <img [src]="getProfileImage(seat.profile, seat.prm)" class="h-5 w-5 rounded-full" alt="profile">
                                        </div>
                                    }
    
                                    <!-- Name input -->
                                    <div class="flex flex-col justify-center gap-2">
                                        <label class="pl-1">{{ literalService.get('bookings.seats.name', true) }}</label>
                                        <input type="text"
                                            class="w-60 h-10 px-2 rounded border neutrals-grey-02-border neutrals-white-background"
                                            [(ngModel)]="seat.name"
                                            [disabled]="!editable || confirmChange"
                                            [style.anchor-name]="'--nameAnchor-' + seatIndex"
                                            (focus)="filterNames(seat.name || ''); openPopover(nameMenu, filteredNames.length > 0)"
                                            (input)="onNameInputChange($event); openPopover(nameMenu, filteredNames.length > 0)"
                                            (focusout)="closePopover(nameMenu)">
                                        <div #nameMenu popover="manual" class="dropdown" [style.position-anchor]="'--nameAnchor-' + seatIndex">
                                            <div class="w-60 rounded bg-white shadow p-1 flex flex-col gap-1 max-h-48 scrollable-content">
                                                @for (name of filteredNames; track $index) {
                                                    <div class="menu-option cursor-pointer px-2 py-1 rounded truncate"
                                                        (mousedown)="$event.preventDefault()"
                                                        (click)="onNameOptionSelected(name, seatIndex); closePopover(nameMenu)">
                                                        {{ name }}
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
    
                                    <!-- Need selector -->
                                    <div class="flex flex-col justify-center gap-2">
                                        <label class="pl-1">{{ literalService.get('bookings.seats.need.', true) }}</label>
                                        <input type="text"
                                            class="w-60 h-10 px-2 rounded border neutrals-grey-02-border neutrals-white-background"
                                            [(ngModel)]="seat.need"
                                            [disabled]="!editable || confirmChange"
                                            [style.anchor-name]="'--needAnchor-' + seatIndex"
                                            (focus)="onNeedFocus(seat.profile); openPopover(needMenu, filteredNeeds.length > 0)"
                                            (input)="onNeedInputChange($event, seat.profile); openPopover(needMenu, filteredNeeds.length > 0)"
                                            (focusout)="closePopover(needMenu)">
                                        <div #needMenu popover="manual" class="dropdown" [style.position-anchor]="'--needAnchor-' + seatIndex">
                                            <div class="w-60 rounded bg-white shadow p-1 flex flex-col gap-1 max-h-48 scrollable-content">
                                                @for (need of filteredNeeds; track $index) {
                                                    <div class="menu-option cursor-pointer px-2 py-1 rounded truncate"
                                                        (mousedown)="$event.preventDefault()"
                                                        (click)="seat.need = displayNeed(need); closePopover(needMenu)">
                                                        {{ literalService.get('bookings.seats.need.' + need, true) }}
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
    
                                    @if (editable) {
                                        <!-- Delete -->
                                        <div class="flex justify-center w-6 h-10">
                                            <img type="button" [src]="images.booking.actions.delete"
                                                (click)="booking.bookingSeats.length > 1 && delete($index)"
                                                class="cursor-pointer" [ngClass]="{'disabled': booking.bookingSeats.length <= 1}"/>
                                        </div>
                                    } 
                                    @else {
                                        <!-- Report -->
                                        <div class="flex justify-center">
                                            <img type="button" [src]="images.booking.actions.missed"
                                                [tooltip]="seat.noShow ? literalService.get('bookings.tooltips.unMarkAsAFault', true) : literalService.get('bookings.tooltips.markAsAFault', true)"
                                                [position]="TooltipPosition.BELOW"
                                                (click)="reportSeat(seat)"
                                                class="cursor-pointer"
                                                [ngClass]="{'missed': seat.noShow }"/>
                                        </div>
                                    }
                                </div>
                            }
                        </div>
                    </div>
                }
            </div>
            @if (showNotify) {
                @if (showRecomputePriceToggle) {
                    <div class="flex items-center">
                        <div class="flex gap-2 items-center min-w-[12rem]">
                            <img [src]="images.booking.fare" alt="recomputePrice" class="h-6 w-6" />
                            <label class="font-bold">{{ literalService.get('bookings.actions.editBooking.recomputePrice', true) }}</label>
                        </div>
                        <app-toggle [id]="'recomputePrice'" [checked]="recomputePrice" (change)="recomputePrice = !recomputePrice;"></app-toggle>
                    </div>
                }
                <div class="flex items-center mt-2">
                    <div class="flex gap-2 items-center min-w-[12rem]">
                        <img [src]="images.booking.notifications" alt="notify" class="h-6 w-6" />
                        <label class="font-bold">{{ literalService.get('bookings.actions.deleteBooking.notify', true) }}</label>
                    </div>
                    <app-toggle [id]="'notify'" [checked]="notify" (change)="notify = !notify;"></app-toggle>
                </div>
            }
            @if (confirmChange) {
                <div class="my-8 max-w-[500px]">
                    <p class="font-bold mb-2">{{ literalService.get('bookings.actions.editBooking.ticketingAlert.title', true) }}</p>
                    <p class="text-base font-normal">{{ literalService.get('bookings.actions.editBooking.ticketingAlert.pre', true) }}<span class="primary-purple-text font-semibold">{{ literalService.get('bookings.actions.editBooking.ticketingAlert.highlight', true) }}</span>{{ literalService.get('bookings.actions.editBooking.ticketingAlert.post', true) }}</p>
                </div>
            }
            @if (editable) {
                <div class="flex justify-end space-x-4">
                    <button type="button"
                        (click)="onCancel()"
                        class="secondary mt-2 p-2 border-2 w-28 font-semibold uppercase cursor-pointer">{{
                        literalService.get('cancel', true) }}</button>
                    <button type="button"
                        [disabled]="this.booking && this.booking.prmSeats == 0 && this.booking.seats == 0"
                        class="primary mt-2 p-2 border-2 w-28 font-semibold text-white uppercase cursor-pointer"
                        (click)="onSubmit()">{{ literalService.get(confirmChange ? 'confirm' : 'update', true) }}</button>
                </div>
            }
        </div>
    </div>
</div>